import React, { useState } from 'react';

import './channel-modal.scss';

const channels = ['TikTok', 'Instagram', 'YouTube', 'Facebook', 'Site', 'Newsletter', 'Other'];

function ChannelModal({ channel, setChannel, setShowChannel }) {
  const [temp, setTemp] = useState(channel);

  const channelRows = channels.map((item, i) => {
    return (
      <div key={i} className={`channel ${item}`} onClick={() => setTemp(item)}>
        <div className={`bubble ${temp === item ? 'fill' : ''}`}>
          <div></div>
        </div>
        <span className="text">{item}</span>
      </div>
    );
  });

  return (
    <div className="channel-picker">
      <div className="container">
        <div className="item-container">
          <div className="header">Select Channel</div>
          {channelRows}
        </div>
        <div className="buttons">
          <div className="cancel-btn" onClick={() => setShowChannel(false)}>
            Cancel
          </div>
          <div
            className="select-btn"
            onClick={() => {
              setChannel(temp);
              setShowChannel(false);
            }}
          >
            Select
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChannelModal;
